module.exports = __webpack_public_path__ + "img/legia-napoli.ab38f21a.jpg";